export default {
  询比价管理列表: "询比价管理列表",
  新增询价: "新增询价",
  保存成功: "保存成功",
  请添加询价物料: "请添加询价物料",
  请添加询价物料名称: "请添加询价物料名称",
  请添加供应商: "请添加供应商",
  询价基本信息: "询价基本信息",
  询价类型: "询价类型",
  请选择询价类型: "请选择询价类型",
  询价单标题: "询价单标题",
  请输入询价单标题: "请输入询价单标题",
  截止时间: "截止时间",
  请选择截止时间: "请选择截止时间",
  询价明细: "询价明细",
  搜索物料: "搜索物料",
  添加物料行: "添加物料行",
  序号: "序号",
  物料编号: "物料编号",
  "物料名称（中文）": "物料名称（中文）",
  "物料名称（英文）": "物料名称（英文）",
  "商品名称（如有）": "商品名称（如有）",
  药典: "药典",
  标准: "标准",
  数量: "数量",
  数量单位: "数量单位",
  备注: "备注",
  请输入: "请输入",
  材料结构: "材料结构",
  尺寸: "尺寸",
  其他要求: "其他要求",
  类别: "类别",
  物料代号: "物料代号",
  物料名称: "物料名称",
  "CAS No. | Catalogue No.（供应商目录号）":
    "CAS No. | Catalogue No.（供应商目录号）",
  "建议包装规格（如：25kg/袋）": "建议包装规格（如：25kg/袋）",
  "备注(品牌/等级要求）": "备注(品牌/等级要求）",
  供应商选择: "供应商选择",
  共count个供应商: "共{count}个供应商",
  清空: "清空",
  从供应商库选择: "从供应商库选择",
  暂无供应商: "暂无供应商",
  全选: "全选",
  未命名供应商: "未命名供应商",
  "绑定需求申请单(如有)": "绑定需求申请单(如有)",
  添加: "添加",
  询价单号: "询价单号",
  询价状态: "询价状态",
  标题: "标题",
  创建人: "创建人",
  创建时间: "创建时间",
  截止日期: "截止日期",
  报价进度: "报价进度",
  操作: "操作",
  比价: "比价",
  询价单基本信息: "询价单基本信息",
  导出: "导出",
  询价单编号: "询价单编号",
  物料类型: "物料类型",
  询价日期: "询价日期",
  关联需求单: "关联需求单",
  询价单要求明细: "询价单要求明细",
  目标供应商数量: "目标供应商数量",
  已报价供应商数量: "已报价供应商数量",
  "最低报价（总价）": "最低报价（总价）",
  "最高报价（总价）": "最高报价（总价）",
  物料index: "物料{index}",
  导出当前物料: "导出当前物料",
  比价单: "比价单",
  价格对比: "价格对比",
  更多明细: "更多明细",
  该供应商未填写报价: "该供应商未填写报价",
  查看更多: "查看更多",
  供应商名称: "供应商名称",
  总价: "总价",
  单价: "单价",
  货币: "货币",
  最低起订量: "最低起订量",
  国际贸易条款: "国际贸易条款",
  交货期: "交货期",
  产地: "产地",
  发货地点: "发货地点",
  是否含运费: "是否含运费",
  是: "是",
  否: "否",
  备注说明: "备注说明",
  单位HKD: "单位：HKD",
  填报明细: "填报明细",
  报名截止日期: "报名截止日期：",
  提交成功: "提交成功",
  总结: "总结",
  请输入总结: "请输入总结",
  返回: "返回",
  品牌: "品牌",
  产品货号: "产品货号",
  等级: "等级",
  产品名称: "产品名称",
  规格: "规格",
  单位: "单位",
  折扣: "折扣",
  "交货期/天": "交货期/天",
  最小包装规格: "最小包装规格",
  物料文件: "物料文件",
  样品测试情况: "样品测试情况",
  是否符合澳美的物料信息: "是否符合澳美的物料信息",
  关闭: "关闭",
  暂存: "暂存",
  发送询价: "发送询价",
};
